import React, { Component } from 'react';
import {
  Facet,
} from "@elastic/react-search-ui";
import CustomFacet from "./CustomFacet";
import {
  MultiCheckboxFacet,
  BooleanFacet
} from "@elastic/react-search-ui-views";
import MultiCheckboxFacetTrans from "./MultiCheckBoxFacetTrans";
import { withStyles } from "@material-ui/core/styles";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';

const styles = theme => ({
  
});

class FiltersMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      logged: this.props.logged,
      family_list: this.props.family_list,
      family: this.props.family,
      family_filters: this.props.family_filters,
      label_list: this.props.label_list,
      config: this.props.config,
      sub_filters: [],
    };
  }

  setFilters() {
    const { family, family_filters } = this.state;
    let { config } = this.state;
    let current_family="";
    if (family != "" && family != null) {
      current_family=family;

      if (Object.hasOwnProperty.call(family_filters, current_family)) {
        
        for (const key in family_filters[current_family]) {
          const filter_id = family_filters[current_family][key];
          // En caso de que el cliente quiera seleccionar varias opciones del filtro simultaneamente, se descomentaría esta línea
          config.searchQuery.disjunctiveFacets.push(filter_id);
          if (filter_id != "") {
            config.searchQuery.facets[filter_id] = {
              type: "value", size: 50
            };
          }
        }

        this.setState({
          sub_filters: family_filters[current_family],
          config: config
        });
      }

    }
    else {
      current_family="default";

      for (const key in family_filters[current_family]) {
        const filter_id = family_filters[current_family][key];
        // En caso de que el cliente quiera seleccionar varias opciones del filtro simultaneamente, se descomentaría esta línea
        //config.searchQuery.disjunctiveFacets.push(filter_id);
        if (filter_id != "") {
          config.searchQuery.facets[filter_id] = {
            type: "value", size: 50
          };
        }
      }

      this.setState({
        sub_filters: family_filters[current_family],
        config: config
      });
    }
     
    
  }

  componentDidMount() {
    this.setFilters();
  }

  render() {
    const { lang, logged, family_list, family, config, family_filters, label_list, sub_filters } = this.state;
    const { t } = this.props;
    const { classes } = this.props;
    //if(sub_filters.length>0) {
    let result= (
        <div>
          {Object.keys(sub_filters).map(key => {
            
            let label = sub_filters[key];
            if (Object.hasOwnProperty.call(label_list, sub_filters[key])) {
              label = label_list[sub_filters[key]];
            }
            if (label != "") {
              return <CustomFacet key={sub_filters[key]} field={sub_filters[key]} label={label} filterType="any" view={MultiCheckboxFacetTrans} />
            }
          })}
        </div>
      );

      return result;
    //}
    /*else {
      // Cuando es engine principal vemos las Familias
      return <div><Facet field="lg_1" label={label_list['lg_1']} filterType="any" view={MultiCheckboxFacetTrans} isFilterable={true} searchPlaceholder={t("Family_name")}/></div>
    }*/
  }
}

export default withStyles(styles)(withTranslation()(FiltersMenu));